import { render, staticRenderFns } from "./PolicyHolderCreateView.vue?vue&type=template&id=944539f0&"
import script from "./PolicyHolderCreateView.vue?vue&type=script&lang=js&"
export * from "./PolicyHolderCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports